import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as AssessmentSessionActions from "../../state/redux/assessmentSession";
import { deepCopyObject, getOnboardingLabelFromAssessmentType } from "../../utils/helpers";
import SurveyAssessments from "../ui/surveyAssessments";
import Widget from "../ui/widget";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetSurveyContent from "../ui/widgetSurveyContent";
import WidgetTitle from "../ui/widgetTitle";

const AdminAssessments = props => {
  const {
    assessmentODMs,
    loadAssessmentsRequest,
    assessmentPageLoading,
    assessmentPagination,
    assessmentPaginationFocus,
  } = props;

  useEffect(() => {
    if (assessmentODMs != null) {
      setRows(assessmentODMs);
    }
  }, [assessmentODMs]);

  useEffect(() => {
    if (assessmentPaginationFocus != null) {
      let newPage = deepCopyObject(assessmentPagination);
      newPage.invalidateCache = true;
      loadAssessmentsRequest(newPage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentPaginationFocus, loadAssessmentsRequest]);

  const [rows, setRows] = useState([]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (assessmentPagination != null) {
      setTitleText(
        `${assessmentPagination.totalItems} ${getOnboardingLabelFromAssessmentType(
          assessmentPaginationFocus,
        )} Assessment${assessmentPagination.totalItems === 1 ? "" : "s"}`,
      );
    } else {
      setTitleText("Loading...");
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentPagination]);

  return (
    <Widget>
      <WidgetTitle title={"Assessments"} text={titleText}></WidgetTitle>

      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyAssessments
            assessmentODMs={rows}
            onRequestNewPage={loadAssessmentsRequest}
            isLoading={assessmentPageLoading}
            assessmentPagination={assessmentPagination}
            assessmentPaginationFocus={assessmentPaginationFocus}
          />
        </WidgetSurveyContent>
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  assessmentODMs: state.assessmentSession.assessmentODMs,
  assessmentPageLoading: state.assessmentSession.assessmentPageLoading,
  assessmentPagination: state.assessmentSession.assessmentPagination,
  assessmentPaginationFocus: state.assessmentSession.assessmentPaginationFocus,
});

const mapDispatchToProps = {
  loadAssessmentsRequest: AssessmentSessionActions.loadAssessmentsRequest,

  deleteAssessmentRequest: AssessmentSessionActions.deleteAssessmentRequest,
  setAssessmentODMRequest: AssessmentSessionActions.setAssessmentODMRequest,
  updateAssessmentRequest: AssessmentSessionActions.updateAssessmentRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminAssessments));
